<div class="main-container clarichat">
  <div class="top-bar d-flex justify-content-between align-items-center"></div>

  <div class="messages-container" #messagesContainer>

    <!-- Chat Placeholder -->
    <div class="chat-placeholder-grid-container" *ngIf="currentMessages.length === 0 && !isLoading">
      <img [src]="currentLogo" [class.fading]="logoFading" [class.clari-logo]="currentLogo.includes('iamclari2')" class="grid-item-logo vendor-logo">
      <h1 class="placeholder-title" *ngIf="!showMainSubtitle">
        <span class="model-name">{{ currentModelName }}</span>
      </h1>
      <h1 class="placeholder-subtitle jizz bigal-sub" *ngIf="showMainSubtitle">
        The Leading AI Models, All In One Place. 
      </h1>
      <h1 class="placeholder-subtitle bigal-sub" *ngIf="!showMainSubtitle" [class.fading]="logoFading">
        {{ currentPlaceholder }}
      </h1>
    </div>

    <!-- Message Display -->
    <div class="message" *ngFor="let msg of currentMessages; let i = index; trackBy: trackMsg"
         [id]="'msg-' + msg.id"
         [ngClass]="{'user-message': msg.role === 'user', 'assistant-message': msg.role === 'assistant'}">

      <!-- Message Content -->
      <div *ngIf="msg.content" class="markdown prism-content" [innerHTML]="convertMarkdown(msg.content)" appCodeHighlight></div>

      <!-- Images -->
      <img
        *ngFor="let img of (msg.images || (msg.image ? [msg.image] : []))"
          [src]="
            img.startsWith('http') || img.startsWith('data:')
              ? img
              : 'data:image/jpeg;base64,' + img
          "
          class="ai-image mt-2 me-2"
          style="max-width: 100%; border-radius: 8px"
        />

      <!-- Video Section -->
      <div *ngIf="msg.modelId === 'veo' || msg.modelId === 'cogvideox3' || msg.videoId || msg.video || msg.thumbnail" class="video-message">

        <!-- Thumbnail Preview -->
        <img *ngIf="msg.thumbnail && !msg.video" [src]="msg.thumbnail" class="video-thumb" />

        <!-- Progress Loader -->
        <div *ngIf="!msg.video" class="video-progress">
          <app-bird-loader label="Thinking"></app-bird-loader>
          <span *ngIf="msg.progress != null">{{ msg.progress }}%</span>
        </div>

        <!-- Final Video -->
        <video *ngIf="msg.video" [src]="msg.video" controls playsinline></video>
      </div>

      <!-- Timestamp -->
      <div class="message-timestamp">
  {{ msg.timestamp | date: 'short' }}
  <span *ngIf="msg.modelDisplayName">— {{ msg.modelDisplayName }}</span>
  <span *ngIf="msg.role === 'user'">— Me</span>
      </div>

    </div>

    <!-- Loading Indicator -->
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>

  </div>

<!-- Input Container -->
  <div class="bottomcontainer">
<div class="input-container">
  <button class="scroll-to-bottom-btn"
    *ngIf="showScrollToBottom"
    (click)="scrollToBottom()"
          aria-label="Scroll to bottom">
    ↓
  </button>

  <div class="composer-shell" [ngClass]="{ 'with-effort': selectedModel === 'o3' }">

    <input #fileInput type="file" accept="image/*"
        (change)="onFileSelected($event)"
           style="display:none">

    <div class="textarea-wrapper">
      <textarea
        #chatTextarea
        id="chatInputTextarea"
        class="user-input-textarea"
        [(ngModel)]="userInput"
        rows="1"
        (input)="autoResize(chatTextarea)"
        [placeholder]="getTextareaPlaceholder()"
        (keydown)="onKeyDown($event)">
      </textarea>

      <!-- Right floating send -->
      <button id="sendMessageButton"
        class="btn-send-fixed"
              type="button"
        (click)="sendMessage()"
        [disabled]="isLoading || !userInput.trim()">
        <i class="fas fa-arrow-up"></i>
      </button>

      <!-- Model Grid - Inside textarea area -->
      <div class="model-grid-inside">
        <!-- AI Menu Button -->
        <div class="grid-item-inside selector">
          <button id="aiCatalogBtn" class="elegant-btn lovesheet33" (click)="openAICatalog()">
            <span class="btn-icon">
              <img src="assets/select-white.svg" class="selectai-icon">
            </span>
            <span class="btn-text">AI</span>
            <i class="fas fa-chevron-down btn-chevron"></i>
        </button>
        </div>

        <!-- Model Name Display -->
        <div class="grid-item-inside selector">
          <button class="elegant-btn lovesheet2" type="button" (click)="openModelSpecDialog()">
            <span class="btn-text">{{ selectedModelName }}</span>
          </button>
        </div>

        <!-- Reuse Prompt Button -->
        <div class="grid-item-inside selector">
          <button
            *ngIf="messageHistory.length > 0"
            id="previousPromptsBtn"
            class="elephant-btn lovesheet11"
            [class.repeat-active]="isRepeatPromptActive"
            matTooltip="Cycle through your prompts (or press ↑/↓)"
            (click)="cyclePromptHistory()">
            <span class="btn-icon">
              <i class="fas fa-clock-rotate-left"></i>
            </span>
            <span class="btn-text">Prompt</span>
          </button>
        </div>

        <!-- More Tools -->
        <div class="grid-item-inside selector" #menuContainer>
          <div class="video-menu-anchor" (click)="$event.stopPropagation()">
            <div
              class="video-generator-menu"
              [class.open]="showVideoGeneratorMenu"
              *ngIf="showVideoGeneratorMenu">
              <button type="button" (click)="openVeoVideoGenerator(); showVideoGeneratorMenu = false">
                <span class="icon">🎬</span> Veo 3.1 Video Generator
              </button>

              <button type="button" (click)="openCogXVidGenerator(); showVideoGeneratorMenu = false">
                <span class="icon">🎥</span> CogXVid Generator
              </button>
            </div>
             
                <div class="grid-item-inside selector">
                  <button id="aiCatalogBtn" class="elegant-btn tools-trigger lovesheet1" (click)="showVideoGeneratorMenu = !showVideoGeneratorMenu">
                    <span class="btn-icon">
                      <mat-icon svgIcon="settings"></mat-icon>
                    </span>
                    <i class="fas fa-chevron-down btn-chevron"></i>
                  </button>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="video-controls" *ngIf="selectedModel === 'veo' || selectedModel === 'cogxvid'">
  <!-- Upload Image Reference -->
  <div class="upload">
    <input type="file" accept="image/png,image/jpeg,image/webp" (change)="onPickImage($event)">
    <button *ngIf="uploadImageFile" (click)="clearImage()">Remove image</button>

    <div class="preview" *ngIf="uploadImagePreviewUrl">
      <img [src]="uploadImagePreviewUrl" alt="reference image">
      <div class="caption">Image Upload</div>
    </div>
  </div>

  <!-- 3-minute UI Progress Bar for Video Generation -->
  <div class="genbar" *ngIf="generating">
    <div class="genrow">
      <span class="videoIcon flashing">🎥</span>
      <span class="genText">Generating video…</span>
      <span class="pct">{{ uiProgress }}%</span>
    </div>
    <div class="bar">
      <div class="fill" [style.width.%]="uiProgress"></div>
      </div>
    </div>
  </div>
</div>
